


import Formulario from '../../components/globe/componente'
import React, { useEffect, useState } from "react";


export default function Paginas() {
  


   
            return (
                <>
           
              <div  >
        <br/>
       
                <Formulario/>
                
                </div>
              
     
                
          
                </>
           
            );
        
        }